import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, errorMessage: String }

  async push(event) {
    event.preventDefault()

    const form = this.element.closest("form")
    if (!form) return

    const trigger = event.currentTarget
    trigger.classList.add("disabled")

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          Accept: "application/json",
        },
        body: new FormData(form),
      })

      const data = await response.json().catch(() => ({}))
      if (!response.ok) {
        this.notify(data.message || this.errorMessageValue)
        return
      }

      this.notify(data.message || this.errorMessageValue)
    } catch (error) {
      console.error("VMS push failed:", error)
      this.notify(this.errorMessageValue)
    } finally {
      trigger.classList.remove("disabled")
    }
  }

  notify(message) {
    window.dispatchEvent(new CustomEvent("notify", { detail: { message } }))
  }
}
